export default __webpack_public_path__ + "54c13b6e8ee3e06ff7669e23ed6cf93a.png";